<template>
  <v-sheet>
    <headline-bar>
      <template v-slot:prepend-btn>
        <v-btn icon @click.stop="dismissSideSheet">
          <v-icon>{{
            sideSheetIsOn && $vuetify.breakpoint.xs ? icons.back : icons.close
          }}</v-icon>
        </v-btn>
      </template>

      Contact info
    </headline-bar>

    <v-form ref="form" v-model="valid" lazy-validation class="pa-6 flex-grow-1">
      <!-- MOBILE GROUP -->
      <p class="caption text--secondary pa-0 mb-2 test">Mobile</p>

      <div class="d-flex flex-row">
        <!-- Area code -->
        <v-autocomplete
          @contextmenu="disableContextMenu"
          v-model="selectedCode"
          :items="areaCodes"
          return-object
          item-text="name"
          item-value="name"
          label="Area code"
          placeholder="Select ..."
          no-data-text="Area code is not available"
          required
          filled
          color="secondary"
          prefix="+"
          class="mr-4"
          style="max-width: 128px"
        >
        </v-autocomplete>

        <!-- Phone Number -->
        <v-text-field
          v-model="number"
          :rules="numberRules"
          @keypress="isNumber($event)"
          label="Mobile number"
          placeholder=""
          type="number"
          filled
          color="secondary"
          class="flex-shrink-1"
          autofocus
        ></v-text-field>
      </div>

      <v-btn
        :light="$vuetify.theme.dark"
        :dark="!$vuetify.theme.dark"
        class="float-right"
        @click="contactChange"
      >
        Submit
      </v-btn>
    </v-form>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      number: "",
      selectedCode: "",
      areaCodes: [{ name: "82" }, { name: "123" }, { name: "456" }],

      valid: true,
      numberRules: [
        (numberValue) => !!numberValue || "Required",
        (numberValue) => /[0-9]/.test(numberValue) || "Number must be valid",
      ],
    };
  },
  computed: {
    sideSheetIsOn() {
      return this.$store.getters["SideSheet/isOn"];
    },
    contactInfo() {
      return this.$store.getters["Profile/contactInfo"].mobile.value;
    },
    regionsArray() {
      return this.$store.getters["Regions/regionsArray"];
    },
  },

  methods: {
    dismissSideSheet() {
      this.$store.dispatch("SideSheet/toggleSideSheet", { isOn: false });
    },

    contactChange() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("Profile/contactChange", {
          areaCode: this.selectedCode.name,
          number: this.number,
        });
        this.dismissSideSheet();
      }
    },

    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },

  mounted() {
    this.sideSheet = this.sideSheetIsOn;
    this.selectedCode = { name: this.contactInfo.areaCode };
    this.number = this.contactInfo.number;
  },
};
</script>

<style lang="sass" scoped>
.v-select
  &:not(.v-text-field--single-line):not(.v-text-field--outlined)
    ::v-deep .v-select__slot
      > input
        align-self: flex-start

  &.v-autocomplete.v-input--is-focused
    ::v-deep input
      min-width: 0
</style>
